import dayjs from 'dayjs';
import gql from 'graphql-tag';

import { useMetricQueries } from '../../lib/hooks';
import { createBatchedFetcher } from '../../lib/gqlFetcher_myf2b';

const fetcher = createBatchedFetcher(5);

const QUERY = gql`
	query metrics_contentTreeUserWritings(
		$entityType: EntityType!,
		$entityId: ID!,
		$curriculumId: String!,
		$path: ContentTreePath!,
	) {
		metrics(entityId: $entityId, entityType: $entityType) {
			contentTreeUserWritings(curriculumId: $curriculumId, path: $path){
				contentId
				createdAt
				updatedAt
				timeSpent
				score
				viewParams {
					contentId
					sessionId
					userId
				}
			}
		}
	}
`;

const useContentTreeUserWritings = (entities) => useMetricQueries(
	entities.map(
		([entityType, entityId, curriculumId, path]) => ({
			document: QUERY,
			variables: { entityType, entityId, curriculumId, path },
			options: {
				queryKey: ['metrics_contentTreeUserWritings', entityType, entityId, curriculumId, path],
				transformer: ({ metrics: { contentTreeUserWritings } }) => ({
					entityType,
					entityId,
					curriculumId,
					path,
					writings: contentTreeUserWritings.map(entry => ({
						...entry,
						createdAt: entry.createdAt && dayjs(entry.createdAt),
						updatedAt: entry.updatedAt && dayjs(entry.updatedAt),
					})),
				}),
			},
		})
	),
	fetcher,
);
export default useContentTreeUserWritings;
